import { defineBoot } from '@quasar/app-vite/wrappers';
import store from 'src/store';

/**
 * Adds the global $store property
 */
export default defineBoot(({ app }) => {
  app.config.globalProperties.$store = store();
  app.provide('store', store());
});
